import SkillPane from "./SkillPane";

export default SkillPane;
export { SkillPane };
